// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminSalesMetrics = (client) => ({
    /**
     * `POST /admin/sales-metrics/recompute`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSalesMetricsRecompute
     * @source apps/backend/src/api/admin/sales-metrics/recompute/route.ts
     */
    updateRecompute: (body, query, headers) => client.fetch("/admin/sales-metrics/recompute", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=sales-metrics.js.map